class NewsletterFooter extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector(".js-newsletter-footer-form");
    this.emailInput = this.querySelector(".js-klaviyo-email");
    this.successMessage = this.querySelector(".js-klaviyo-success");
    this.errorMessageWrapper = this.querySelector('.js-error-wrapper') || false;
    this.errorMessageEl = this.errorMessageWrapper.querySelector('.js-error-message') || false;
    this.url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe'

    this.form.addEventListener("submit", this.handleSubmit.bind(this));
  }

  handleSubmit(e) {
    e.preventDefault();

    this.handleErrorMessage(false);
    this.handleSuccessMessage(false);

    const serialized = JSON.parse(serializeForm(this.form));

    if (serialized.email == "") {
      this.emailInput.focus();
      this.emailInput.setAttribute("aria-invalid", "true");
      this.emailInput.setAttribute("aria-describedby", 'Email is required');
      return this.handleErrorMessage('Email is required');
    }

    if (serialized.email != "" && !validateEmail(serialized.email)) {
      this.emailInput.focus();
      this.emailInput.setAttribute("aria-invalid", "true");
      this.emailInput.setAttribute("aria-describedby", 'Email error');
      return this.handleErrorMessage('Invalid email')
    } else {
      this.emailInput.setAttribute("aria-invalid", "false");
      this.emailInput.removeAttribute("aria-describedby");
      this.handleErrorMessage(false)
    }

    if ((serialized.email != "") && (validateEmail(serialized.email))) {
      this.fetchRequest(serialized)
        .then((response) => {
          if (response.errors.length) {
            this.handleErrorMessage(response.errors[0])
          }
          if (response.success && response.data) {
            this.handleSuccessMessage(true)
            this.clearForm()
          }
        })
        .catch((error) => {
          console.error(error)
        });
    }
  }

  async fetchRequest(data) {
    const formData = {
      g: Shopify.settings.klaviyo.list_id,
      $fields: "subscription, $source",
      email: data.email,
      subscription: data.subscription,
      consent: true,
      $source: 'Klaviyo newsletter form'
    }

    const body = new URLSearchParams(formData)

    const req = await fetch(this.url, {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
      body
    })

    const response = await req.json();
    return response;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper && this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessageEl.textContent = errorMessage;
    }
  }

  handleSuccessMessage(state) {
    this.successMessage.classList[state ? 'remove' : 'add']('hidden')
  }

  clearForm() {
    this.handleErrorMessage(false)
    this.emailInput.value = ""
  }
}

customElements.define("newsletter-footer-form", NewsletterFooter);
